import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';

/**
 * P Image Badge Setting Handler
 */
export class ShBadgePositonDirection extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {}

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      $activePanel: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;
    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (!targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      if (this.setting.options?.length) {
        for (let i = 0; i < this.setting.options.length; i++) {
          const option = this.setting.options[i];
          if (option.key == value) {
            value = option.value;
          }
        }
      }
      const $badgeAnchor = options.$atom.find('.gf_product-badge-anchor');
      let deOptions: any = [];
      if ($badgeAnchor.hasClass('gf_pb_top-left') || $badgeAnchor.hasClass('gf_pb_top-right')) {
        deOptions = [
          {
            key: 'top',
            value: options.$activePanel.find('#badgePositionTop').val(),
          },
        ];
      }
      if ($badgeAnchor.hasClass('gf_pb_bottom-left') || $badgeAnchor.hasClass('gf_pb_bottom-right')) {
        deOptions = [
          {
            key: 'bottom',
            value: options.$activePanel.find('#badgePositionBottom').val(),
          },
        ];
      }
      if ($badgeAnchor.hasClass('gf_pb_top-left') || $badgeAnchor.hasClass('gf_pb_bottom-left')) {
        deOptions = [
          {
            key: 'left',
            value: options.$activePanel.find('#badgePositionLeft').val(),
          },
        ];
      }
      if ($badgeAnchor.hasClass('gf_pb_top-right') || $badgeAnchor.hasClass('gf_pb_bottom-right')) {
        deOptions = [
          {
            key: 'right',
            value: options.$activePanel.find('#badgePositionRight').val(),
          },
        ];
      }
      style = HELPER.designOptions2Style(
        $badgeAnchor,
        options.screenType,
        style,
        deOptions,
        '.gf_product-badge-anchor',
      );
    }
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
